import { v4 as uuidv4 } from 'uuid'

export const generateId = () => {
  const id = uuidv4()
  const slicedUuid = id.substring(id.length - 8)
  return slicedUuid.toUpperCase()
}
